module.exports = __webpack_public_path__ + "img/addressHomeIcon.4fef4a63.svg";